<template lang='pug' src='./home.pug'></template>

<script>
import Loader from 'components/loader/loader'
import Header from 'components/header/header'
import Footer from 'components/footer/footer'

export default {
  name: 'home',
  computed: {
    props () {
      return this.$store.state.pages['home']
    },
    propsheader () {
      return this.$store.state.app['header']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    Loader,
    Header,
    Footer
  },
  data () {
    return {
      swiperOption1: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        centeredSlides: true,
        loop: true,
        spaceBetween: 30,
        effect: 'fade',
        speed: 1500,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      intersectionOptions: {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: [0, 1] // [0.50, 0.50] if you want a 50% offset!
      },
      intersectionOptions1: {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: [0, 1] // [0.60, 0.40] if you want a 60% offset!
      }
    }
  },
  methods: {
    onWaypoint ({ going, direction }) {
      // going: in, out
      // direction: top, right, bottom, left
      if (going === this.$waypointMap.GOING_IN) {
        var element1 = document.getElementById('welcome_id').querySelectorAll('.ornament')
        element1[0].classList.add('action')
      }

      if (going === this.$waypointMap.GOING_OUT) {
        var element2 = document.getElementById('welcome_id').querySelectorAll('.ornament')
        element2[0].classList.remove('action')
      }
    },
    onWaypoint1 ({ going, direction }) {
      // going: in, out
      // direction: top, right, bottom, left
      if (going === this.$waypointMap.GOING_IN) {
        var element3 = document.getElementById('service_fish_id').querySelectorAll('.ornament')
        element3[0].classList.add('action')
      }

      if (going === this.$waypointMap.GOING_OUT) {
        var element4 = document.getElementById('service_fish_id').querySelectorAll('.ornament')
        element4[0].classList.remove('action')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// home.vue?cd4bad46